import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import EllipsisTitle from '../../portal/ellipsisTitle';
import TeamManageMenu from '../teamManageMenu';

@inject('translationsStore', 'teamsStore', 'usersStore') @observer
export default class AddTeam extends Component {

    state = {
        open: false
    }

    open = () => {
        
        this.setState({
            open: true
        });
    }

    getTeamNumberTitle(){

        let teamsNumber = '';

        if(this.props.teamsStore.teamsNumber > 0)
        {
            teamsNumber = `${this.props.teamsStore.teamsNumber} ${this.props.translationsStore.translate('TEAMS')}`;
            
            if(this.props.teamsStore.teamsNumber != this.props.teamsStore.displayedTeamsNumber){
                teamsNumber = `${this.props.teamsStore.displayedTeamsNumber}/${teamsNumber}`;
            }
            
            teamsNumber = `(${teamsNumber})`;
        }

        return `${this.props.translationsStore.translate('HIERARCHY')} ${teamsNumber}`;
    }

    render(){

        const title = this.getTeamNumberTitle();

        return(
            <div className='edit-teams-wrapper' data-cy='edit-teams-wrapper'>
                <EllipsisTitle width='85%' title={title} />
                <TeamManageMenu disableTeamMenu={this.props.disableTeamMenu} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/teams/addTeam/index.jsx